import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Container, Typography } from '@mui/material';
// layouts
import LogoOnlyLayout from '../../layouts/LogoOnlyLayout';
// routes
import { PATH_AUTH } from '../../routes/paths';
// components
import Page from '../../components/Page';
import { ResetPasswordForm } from '../../components/authentication/reset-password';
//
// import { SentIcon } from '../../assets';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  return (
    <RootStyle title="Reset Password">
      <LogoOnlyLayout />

      <Container>
        <Box sx={{ maxWidth: 480, mx: 'auto' }}>
          {!sent ? (
            <>
              <Typography variant="h3" paragraph>
                ¿Olvidaste tu contraseña?
              </Typography>
              <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                Escribe el correo asociado a tu cuenta y te mandaremos un link para restablecer tu contraseña.
              </Typography>

              <ResetPasswordForm
                onSent={() => setSent(true)}
                onGetEmail={(value) => setEmail(value)}
              />

              <Button
                fullWidth
                size="large"
                component={RouterLink}
                to={PATH_AUTH.login}
                sx={{ mt: 1 }}
              >
                Atrás
              </Button>
            </>
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              {/* <SentIcon sx={{ mb: 5, mx: 'auto', height: 160 }} /> */}

              <Typography variant="h3" gutterBottom>
                Solicitud mandada con éxito
              </Typography>
              <Typography>
                Hemos enviado un correo de confirmación a  &nbsp;
                <strong>{email}</strong>
                <br />
                Por favor checa tu correo.
              </Typography>

              <Button
                size="large"
                variant="contained"
                component={RouterLink}
                to={PATH_AUTH.login}
                sx={{ mt: 5 }}
              >
                Atrás
              </Button>
            </Box>
          )}
        </Box>
      </Container>
    </RootStyle>
  );
}
